export const skillsBase = [
  {
    image:
      'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg',
    name: 'HTML5',
  },
  {
    image:
      'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg',
    name: 'JavaScript',
  },
  {
    image:
      'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg',
    name: 'React Js',
  },
  {
    image:
      'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg',
    name: 'CSS3',
  },
  {
    image:
      'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg',
    name: 'TypeScript',
  },
  {
    image:
      'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg',
    name: 'Git',
  },
  {
    image:
      'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg',
    name: 'GitHub',
  },
  {
    image: 'https://avatars.githubusercontent.com/u/54212428?s=200&v=4',
    name: 'Chakra UI',
  },
  {
    image: 'https://styled-components.com/logo.png',
    name: 'Styled Components',
  },
  {
    image:
      'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg',
    name: 'Express.js',
  },
  {
    image:
      'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original-wordmark.svg',
    name: 'PostgreSql',
  },
  {
    image:
      'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg',
    name: 'Node.js',
  },
  {
    image:
      'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jest/jest-plain.svg',
    name: 'Jest',
  },
  {
    image:
      'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg',
    name: 'Python',
  },
  {
    image:
      'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg',
    name: 'Django',
  },
];
